export default {"src":"/_next/static/image/public/images/ic_right_pagination_green_arrow.4f8d693b26fde0924d554169c13ffce6.svg","height":15,"width":8};